import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EventNoteIcon from "@mui/icons-material/EventNote";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import azure from "../Assets/Images/azure.png";
import gcp from "../Assets/Images/gcp.png";
import aws from "../Assets/Images/aws.png";
import { Box, Chip, Typography } from "@mui/material";
import { statusFilterOptions } from "../utils/enums";

/***********start using the following to render the checks in the staff(IN SCOPE STAFF) of people's page */
export const employementPresentAndManagerPresent = {
  details: {
    status: "All 2 Pass",
    color: "#057F28",
    backgroundColor: ["#E8FBF3"],
  },
  icon: [
    <CheckCircleOutlineIcon
      sx={{ color: "#057F28 !important" }}
      fontSize="small"
    />,
  ],
  tooltipText: ["All 2 Passing"],
};

export const employementPresentAndManagerAbscent = {
  details: {
    status: "",
    color: "#031B89",
    backgroundColor: ["#E8FBF3", "#E8EAFF"],
  },
  icon: [
    <CheckCircleOutlineIcon
      sx={{ color: "#057F28 !important" }}
      fontSize="small"
    />,
    <EventNoteIcon sx={{ color: "#031B89 !important" }} fontSize="small" />,
  ],
  tooltipText: ["Passing", "Failing"],
};

export const employmentAbscentAndManagerPresent = {
  details: {
    status: "",
    color: "#031B89",
    backgroundColor: ["#E8EAFF", "#E8FBF3"],
  },
  icon: [
    <EventNoteIcon sx={{ color: "#031B89 !important" }} fontSize="small" />,
    <CheckCircleOutlineIcon
      sx={{ color: "#057F28 !important" }}
      fontSize="small"
    />,
  ],
  tooltipText: ["Failing", "Passing"],
};

export const employmentAbscentAndManagerAbscent = {
  details: {
    status: "All 2 Failing",
    color: "#C71414",
    backgroundColor: ["#FEEBEB"],
  },
  icon: [
    <WarningAmberIcon sx={{ color: "#C71414 !important" }} fontSize="small" />,
  ],
  tooltipText: ["All 2 Failing"],
};

/*********end **************/

/************* securityRoles data start ************/
export const securityRolesHeaderColumns = [
  { label: "Role Name", field: "role_name" },
  { label: "Description", field: "role_description" },
  { label: "Assigned to", field: "assigned_to" },
  { label: "Checks", field: "checks" },
  { label: "", field: "action" },
];

export const securityRolesData = [
  {
    id: 1,
    role_name: "Matthew Thompson",
    description: "matthew.thompson@regodit.xyz",
    assigned_to: "",
    email: "christoper.wilsoan@regodit.xyz",
  },
  {
    id: 2,
    role_name: "Matthew Thompson",
    description: "matthew.thompson@regodit.xyz",
    assigned_to: "",
    email: "solpheris@regodit.com",
  },
  {
    id: 3,
    role_name: "Matthew Thompson",
    description: "matthew.thompson@regodit.xyz",
    assigned_to: "",
    email: "sahil@solsphere.ai",
  },
  {
    id: 4,
    role_name: "Matthew Thompson",
    description: "matthew.thompson@regodit.xyz",
    assigned_to: "",
    email: "hars@solpheris.ai",
  },
];

export const RoleDetailsAssignPerson = [
  { id: 1, label: "christoper Wilson" },
  { id: 2, label: "Jennifer Taylor" },
  { id: 3, label: "Anshul Modi" },
];

//Organization -----infrasctucture-----infraCard
export const overviewMainInfraData = [
  { id: 1, icon: azure, label: "Microsoft Azure" },
  { id: 2, icon: gcp, label: "Google Cloud" },
  { id: 3, icon: aws, label: "Aws" },
  { id: 4, icon: aws, label: "Aws" },
  { id: 5, icon: aws, label: "Aws" },
];

//Organization -----infrasctucture-----OverviewTableListHeading
export const OverviewTableListHeadings = [
  // { label: "Entity", field: "all_entity" },
  // { label: "Check ID", field: "check_id" },
  { label: "Description", field: "check_description", width: "50%" },
  // { label: "Check", field: "check_name" },
  { label: "Resource ID", field: "resource_id", width: "35%" },
  // { label: "Resource Name", field: "resource_name" },
  {
    label: "Status",
    field: "status",
    width: "15%",
    filterConfig: {
      filterOptions: statusFilterOptions,
    },
  },
  // { label: "", field: "action" },
];

export const OverviewTableListData = [
  {
    id: 1,
    all_entity: "All Entity",
    check_id: "WR437",
    resource_id: "",
    resource_name: "Prabodh Kumar",
    checks: [],
  },
  {
    id: 2,
    all_entity: "All Entity",
    check_id: "",
    resource_name: "Prabodh Kumar",
    checks: [],
  },
  {
    id: 3,
    all_entity: "All Entity",
    check_id: "WR437",
    resource_name: "",
    checks: [],
  },
  {
    id: 4,
    all_entity: "All Entity",
    check_id: "WR437",
    resource_name: "Prabodh Kumar",
    checks: [],
  },
  {
    id: 5,
    all_entity: "All Entity",
    check_id: "WR437",
    resource_name: "Prabodh Kumar",
    checks: [],
  },
  {
    id: 6,
    all_entity: "All Entity",
    check_id: "WR437",
    resource_name: "Prabodh Kumar",
    checks: [],
  },
  {
    id: 7,
    all_entity: "All Entity",
    check_id: "",
    resource_name: "",
    checks: [],
  },
];

export const InfraListStatus = [
  { id: 1, label: "All", field: "all" },
  { id: 1, label: "Pass", field: "pass" },
  { id: 1, label: "Fail", field: "fail" },
];

// ************************#########/\/\Audit Logs/\/\#########************************ \\

export const logNames = [
  "CLASSIFY_AS_NON_EMPLOYEE",
  "OFFBOARD_EMPLOYEE",
  "ASSIGN_STAFF_ROLE",
  "ASSIGN_REPORTING_MANAGER",
  "ADD_INDIVIDUAL_STAFF",
  "ADD_BULK_STAFF",
  "MANUAL_HRMS_SYNC",
  "REGODIT_TEMPLATE_DOWNLOAD",
  "UPLOAD_POLICY_FILE",
  "APPROVE_POLICY",
  "REJECT_POLICY",
  "SEND_POLICY_FOR_APPROVAL",
  "UPDATE_POLICY",
  "ADMIN_CREATED",
  "SECURITY_ROLE_ASSIGNED",
  "COMPANY_PROFILE_UPDATED",
  "SIGNIN_INFO",
  "SIGNOUT_INFO",
  "ADMIN_REMOVED",
];

export const getLogName = (logName) => {
  switch (logName) {
    case "CLASSIFY_AS_NON_EMPLOYEE":
      return "Classified as Non-Employee";
    case "OFFBOARD_EMPLOYEE":
      return "Employee Offboarded";
    case "ASSIGN_STAFF_ROLE":
      return "Staff Role Assigned";
    case "ASSIGN_REPORTING_MANAGER":
      return "Reporting Manager Assigned";
    case "ADD_INDIVIDUAL_STAFF":
      return "Individual Staff Added";
    case "ADD_BULK_STAFF":
      return "Bulk Staff Added";
    case "MANUAL_HRMS_SYNC":
      return "Manual HRMS Synchronized";
    case "REGODIT_TEMPLATE_DOWNLOAD":
      return "Regodit Template Downloaded";
    case "UPLOAD_POLICY_FILE":
      return "Policy File Uploaded";
    case "APPROVE_POLICY":
      return "Policy Approved";
    case "REJECT_POLICY":
      return "Policy Rejected";
    case "SEND_POLICY_FOR_APPROVAL":
      return "Policy Sent for Approval";
    case "UPDATE_POLICY":
      return "Policy Updated";
    case "ADMIN_CREATED":
      return "Created Admin";
    case "SECURITY_ROLE_ASSIGNED":
      return "Security Role Assigned";
    case "COMPANY_PROFILE_UPDATED":
      return "Company Profile Updated";
    case "SIGNIN_INFO":
      return "Signed In";
    case "SIGNOUT_INFO":
      return "Signed Out";
    case "ADMIN_REMOVED":
      return "Removed Admin";
    default:
      return logName;
  }
};

const getEmployeeName = (staffList, id) => {
  const employeeName = staffList?.getEmployees?.data?.find(
    (val) => Number(val.employee_id) === Number(id)
  ).name;
  return employeeName;
};

const getRoleName = (roleData, id) => {
  const roleName = roleData?.getSecurityRoles?.data?.find(
    (val) => Number(val?.role_id) === Number(id)
  )?.role_name;
  return roleName;
};

export const getDetails = (
  activityLogActionDetails,
  activityLogName,
  staffList,
  roleData
) => {
  if (!activityLogActionDetails?.length) {
    return "_"; // Default if no details
  }

  if (activityLogActionDetails[0]?.details?.employeeId) {
    const action =
      activityLogName === "ASSIGN_STAFF_ROLE"
        ? "Staff Role Assigned to"
        : activityLogName === "ASSIGN_REPORTING_MANAGER"
        ? "Manager Assign to"
        : activityLogName === "CLASSIFY_AS_NON_EMPLOYEE"
        ? "Classify as Non Employee to"
        : "Offboarded";
    return (
      <Box mb={1}>
        <Typography variant="body2">
          {action} :{" "}
          <strong>
            {getEmployeeName(
              staffList,
              activityLogActionDetails[0]?.details?.employeeId
            )}
          </strong>
        </Typography>
      </Box>
    );
  }

  if (
    activityLogActionDetails[0]?.status === true ||
    activityLogActionDetails[0]?.status === false
  ) {
    const detail = activityLogActionDetails[0]?.details[0];

    if (["ADMIN_CREATED", "ADMIN_REMOVED"].includes(activityLogName)) {
      const action =
        activityLogName === "ADMIN_CREATED"
          ? "Created as Admin"
          : "Removed as Admin";
      return (
        <Box mb={1}>
          <Typography variant="body2">
            {action} : <strong>{getEmployeeName(staffList, detail)}</strong>
          </Typography>
        </Box>
      );
    }
  }

  return activityLogActionDetails.map((detail, index) => {
    // Handle other cases (e.g., roleId and employeeId, etc.)
    if (detail?.details?.policyName) {
      return (
        <Box
          key={index}
          mb={1}
          sx={{ display: "flex", alignItems: "center", gap: "5px" }}
        >
          <Typography variant="body2" fontWeight="bold">
            {detail.details.policyName}
          </Typography>
          <Chip
            variant="outlined"
            label={`V${detail.details.file_version}`}
            sx={{ ml: 1 }}
            size="small"
          />
        </Box>
      );
    }
    if (detail?.details?.roleId && detail?.details?.employeeid) {
      return (
        <Box key={index} mb={1}>
          <Typography variant="body2">
            Role Assigned:{" "}
            <strong>{getRoleName(roleData, detail?.details?.roleId)}</strong>
          </Typography>
          <Typography variant="body2" mt={1}>
            Assigned To :{" "}
            <strong>
              {getEmployeeName(staffList, detail?.details?.employeeid)}
            </strong>
          </Typography>
        </Box>
      );
    }

    return "_"; // Default for unrecognized details
  });
};
